// extracted by mini-css-extract-plugin
export default {"faIcon":"List_faIcon__2hFHR","List":"List_List__tt4Sy","menu":"List_menu__6k9Ya"};